<template>
  <transition name="loading-fade">
    <div v-if="show" class="loading-overlay">
      <div class="asteroid-container">
        <!-- 小行星主体 -->
        <div class="asteroid">
          <div class="asteroid-surface"></div>
          <div class="asteroid-crater crater-1"></div>
          <div class="asteroid-crater crater-2"></div>
          <div class="asteroid-crater crater-3"></div>
        </div>

        <!-- 轨道环 -->
        <div class="orbit orbit-1">
          <div class="orbit-dot"></div>
        </div>
        <div class="orbit orbit-2">
          <div class="orbit-dot"></div>
        </div>
        <div class="orbit orbit-3">
          <div class="orbit-dot"></div>
        </div>

        <!-- 星星 -->
        <div class="stars">
          <div class="star star-1"></div>
          <div class="star star-2"></div>
          <div class="star star-3"></div>
          <div class="star star-4"></div>
          <div class="star star-5"></div>
          <div class="star star-6"></div>
          <div class="star star-7"></div>
          <div class="star star-8"></div>
        </div>

        <!-- 加载文字 -->
        <div class="loading-text">
          <span class="loading-label">{{ loadingText }}</span>
          <div class="loading-dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingAnimation",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "加载中",
    },
  },
};
</script>

<style scoped>
/* 加载动画遮罩 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.3s ease;
}

.loading-fade-enter-from,
.loading-fade-leave-to {
  opacity: 0;
}

/* 小行星容器 */
.asteroid-container {
  position: relative;
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 小行星主体 */
.asteroid {
  position: relative;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #8b7355, #6b5d52, #4a4238);
  border-radius: 45% 55% 52% 48% / 48% 45% 55% 52%;
  box-shadow: inset -8px -8px 15px rgba(0, 0, 0, 0.4),
    inset 5px 5px 10px rgba(139, 115, 85, 0.3), 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: asteroid-rotate 3s linear infinite;
  z-index: 2;
}

.asteroid-surface {
  position: absolute;
  inset: 0;
  background: radial-gradient(
      circle at 30% 40%,
      rgba(139, 115, 85, 0.4) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 70% 60%,
      rgba(74, 66, 56, 0.3) 0%,
      transparent 40%
    );
  border-radius: inherit;
}

/* 陨石坑 */
.asteroid-crater {
  position: absolute;
  background: radial-gradient(
    circle,
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.2) 60%,
    transparent
  );
  border-radius: 50%;
  box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.crater-1 {
  width: 18px;
  height: 18px;
  top: 20%;
  left: 25%;
}

.crater-2 {
  width: 12px;
  height: 12px;
  top: 55%;
  right: 20%;
}

.crater-3 {
  width: 15px;
  height: 15px;
  bottom: 25%;
  left: 45%;
}

@keyframes asteroid-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 轨道环 */
.orbit {
  position: absolute;
  border: 2px solid transparent;
  border-radius: 50%;
  animation: orbit-spin linear infinite;
}

.orbit-1 {
  width: 140px;
  height: 140px;
  border-top-color: rgba(102, 126, 234, 0.4);
  border-right-color: rgba(102, 126, 234, 0.2);
  animation-duration: 2s;
}

.orbit-2 {
  width: 180px;
  height: 180px;
  border-top-color: rgba(118, 75, 162, 0.4);
  border-right-color: rgba(118, 75, 162, 0.2);
  animation-duration: 3s;
  animation-direction: reverse;
}

.orbit-3 {
  width: 210px;
  height: 210px;
  border-top-color: rgba(240, 147, 251, 0.3);
  border-right-color: rgba(240, 147, 251, 0.15);
  animation-duration: 4s;
}

.orbit-dot {
  position: absolute;
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  top: -3px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 10px currentColor;
}

.orbit-1 .orbit-dot {
  background: linear-gradient(135deg, #667eea, #764ba2);
  box-shadow: 0 0 10px #667eea;
}

.orbit-2 .orbit-dot {
  background: linear-gradient(135deg, #764ba2, #f093fb);
  box-shadow: 0 0 10px #764ba2;
}

.orbit-3 .orbit-dot {
  background: linear-gradient(135deg, #f093fb, #4facfe);
  box-shadow: 0 0 10px #f093fb;
}

@keyframes orbit-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 星星 */
.stars {
  position: absolute;
  inset: 0;
}

.star {
  position: absolute;
  width: 3px;
  height: 3px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.8);
  animation: star-twinkle 1.5s ease-in-out infinite;
}

.star-1 {
  top: 10%;
  left: 15%;
  animation-delay: 0s;
}

.star-2 {
  top: 20%;
  right: 12%;
  animation-delay: 0.3s;
}

.star-3 {
  bottom: 15%;
  left: 20%;
  animation-delay: 0.6s;
}

.star-4 {
  bottom: 25%;
  right: 18%;
  animation-delay: 0.9s;
}

.star-5 {
  top: 50%;
  left: 8%;
  animation-delay: 0.2s;
}

.star-6 {
  top: 55%;
  right: 8%;
  animation-delay: 0.5s;
}

.star-7 {
  top: 35%;
  left: 5%;
  animation-delay: 0.4s;
  width: 2px;
  height: 2px;
}

.star-8 {
  bottom: 40%;
  right: 5%;
  animation-delay: 0.7s;
  width: 2px;
  height: 2px;
}

@keyframes star-twinkle {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.5);
  }
}

/* 加载文字 */
.loading-text {
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.loading-label {
  font-size: 1rem;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
}

.loading-dots {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}

.dot {
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  animation: dot-bounce 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dot-bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* 响应式 */
@media (max-width: 768px) {
  .asteroid-container {
    width: 180px;
    height: 180px;
  }

  .asteroid {
    width: 60px;
    height: 60px;
  }

  .crater-1 {
    width: 14px;
    height: 14px;
  }

  .crater-2 {
    width: 10px;
    height: 10px;
  }

  .crater-3 {
    width: 12px;
    height: 12px;
  }

  .orbit-1 {
    width: 110px;
    height: 110px;
  }

  .orbit-2 {
    width: 140px;
    height: 140px;
  }

  .orbit-3 {
    width: 170px;
    height: 170px;
  }

  .loading-label {
    font-size: 0.875rem;
  }
}
</style>
